import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";

const TemplateList = styled.ul`
	> li:not(:first-child) {
		margin-top: 20px;
	}
`;

const TemplateItem = styled.li`
	width: 100%;
	min-height: 120px;
	padding: 35px 40px 40px;
	border: 1px solid var(--line-color);
	box-sizing: border-box;
`;

const Title = styled.div`
	display: flex;
	padding-bottom: 22px;
	margin-bottom: 20px;
	border-bottom: 1px dashed var(--line-color);
	justify-content: space-between;
	align-items: baseline;

	h5 {
		font-size: var(--medium-size);
		font-family: "pr-font-medium";
		color: var(--emp-color);
		${Ellipsis(1)}
	}

	a {
		display: inline-block;
		margin-left: 30px;
		font-size: var(--basic-size);
		color: var(--emp-color);
		line-height: 1;
		text-decoration: underline;
		flex-shrink: 0;
	}

	@media print {
		h5 {
			font-size: 28px;
		}
	}
`;

const ThumbnailList = styled.ul<{grid: number}>`
	display: grid;
	gap: 10px;

	${props =>
		props.grid === 2 &&
		`
        grid-template-columns: 1fr 1fr;
        img {
            max-height: 231px;
			&.fallback_thumb {
				height: 231px;
    			object-fit: none;
			}
        }
    `}

	${props =>
		props.grid === 3 &&
		`
        grid-template-columns: 1fr 1fr 1fr;
        img {
            height: 184px;
			&.fallback_thumb {
				height: 184px;
    			object-fit: none;
			}
        }
    `}
`;

const ThumbnailItem = styled.li`
	display: flex;
	flex-direction: column;
	align-items: center;

	img {
		&:not(.fallback_thumb) {
			width: 100%;
			vertical-align: top;
		}
	}

	em {
		margin-top: 15px;
		color: var(--emp-color);
	}

	@media print {
		font-size: 24px;
		em {
			font-size: 24px;
		}
	}
`;

const Text = styled.p`
	margin-top: 12px;
	line-height: 1.6;

	@media print {
		font-size: 24px;
	}
`;

const Notice = styled.div`
	h4 {
		position: relative;
		padding-left: 28px;
		margin-top: 15px;
		color: var(--emp-color);

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			width: 18px;
			height: 18px;
			background: url(${SpriteImage}) no-repeat 0 -328px;
			transform: translateY(-50%);
			content: "";
		}
	}

	@media print {
		h4 {
			font-size: 26px;
		}
	}
`;

const NoticeText = styled.p`
	margin: 3px 0 0 28px;
	line-height: 1.6;

	@media print {
		font-size: 26px;
	}
`;

const InfoBox = styled.div`
	padding: 17px 30px;
	margin-top: 25px;
	background-color: #f3f3f3;
`;

const InfoList = styled.ul`
	display: flex;
	gap: 10px 30px;
	flex-wrap: wrap;

	li {
		position: relative;
		padding-left: 12px;
		line-height: 1;

		&:before {
			position: absolute;
			left: 0;
			top: 50%;
			width: 3px;
			height: 3px;
			border-radius: 50%;
			background-color: var(--bl-color);
			transform: translateY(-50%);
			content: "";
		}
	}
`;

const InfoTitle = styled.span`
	margin-right: 9px;
	font-size: var(--basic-size);
	color: var(--emp-color);

	@media print {
		font-size: 24px;
	}
`;

const InfoContent = styled.span`
	font-size: var(--basic-size);
	color: var(--blue-color);

	@media print {
		font-size: 24px;
	}
`;

export {
	TemplateList,
	TemplateItem,
	Title,
	ThumbnailList,
	ThumbnailItem,
	Text,
	Notice,
	NoticeText,
	InfoBox,
	InfoList,
	InfoTitle,
	InfoContent,
};
